import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Entity Information")
  ])
], -1)
const _hoisted_3 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row d-flex" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Entity Logo", -1)
const _hoisted_10 = { id: "preview" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "row mt-3 d-flex" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Entity Type", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Industry Sector", -1)
const _hoisted_19 = { class: "row mt-3 d-flex" }
const _hoisted_20 = { class: "col-md-8" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Name")
], -1)
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Short Name")
], -1)
const _hoisted_24 = { class: "row mt-3 d-flex" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Number")
], -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Date")
], -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Authority")
], -1)
const _hoisted_31 = { class: "row mt-3" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Telephone")
], -1)
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fax")
], -1)
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Web Url")
], -1)
const _hoisted_40 = { class: "row mt-3" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Address")
], -1)
const _hoisted_43 = { class: "row mt-3" }
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Division", -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "District", -1)
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Upazila/Thana", -1)
const _hoisted_50 = { class: "col-md-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Postcode", -1)
const _hoisted_52 = { class: "row mt-3" }
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Description")
], -1)
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Bill Author", -1)
const _hoisted_59 = { class: "card mb-5 mb-xl-10" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Employee Information")
  ])
], -1)
const _hoisted_61 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_62 = { class: "collapse show" }
const _hoisted_63 = { class: "card-body border-top p-5" }
const _hoisted_64 = { class: "row d-flex" }
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload Employee Image", -1)
const _hoisted_67 = { id: "preview" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "col-md-9" }
const _hoisted_70 = { class: "row mt-3 d-flex" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_73 = { class: "col-md-4" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Role", -1)
const _hoisted_75 = { class: "col-md-4" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of Birth", -1)
const _hoisted_77 = { class: "row mt-3 d-flex" }
const _hoisted_78 = { class: "col-md-4" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_80 = { class: "col-md-4" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Driving License")
], -1)
const _hoisted_82 = { class: "col-md-4" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_84 = { class: "row mt-3 d-flex" }
const _hoisted_85 = { class: "col-md-4" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_87 = { class: "col-md-4" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gender")
], -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select gender", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("option", { valFemaleue: "Other" }, "Other", -1)
const _hoisted_93 = { class: "col-md-4" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Religion ", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("option", { value: "Islam" }, "Islam", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: "Hindu" }, "Hindu", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("option", { value: "Christian" }, "Christian", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("option", { value: "Buddhist" }, "Buddhist", -1)
const _hoisted_100 = { class: "row mt-3" }
const _hoisted_101 = { class: "col-md-3" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Designation")
], -1)
const _hoisted_103 = { class: "col-md-3" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID")
], -1)
const _hoisted_105 = { class: "col-md-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Name")
], -1)
const _hoisted_107 = { class: "col-md-3" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mother's Name")
], -1)
const _hoisted_109 = { class: "row mt-3" }
const _hoisted_110 = { class: "col-md-8" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_112 = { class: "col-md-4" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_114 = { class: "row mt-3" }
const _hoisted_115 = { class: "col-md-8" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_117 = { class: "col-md-4" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_119 = { class: "card mb-5 mb-xl-10" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#user_account",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add User Account")
  ])
], -1)
const _hoisted_121 = {
  id: "user_account",
  class: "collapse show"
}
const _hoisted_122 = { class: "collapse show" }
const _hoisted_123 = { class: "card-body border-top p-5" }
const _hoisted_124 = { "data-kt-stepper-element": "content" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-md-6" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "" }, "Password")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      name: "password",
      class: "fv-plugins-message-container invalid-feedback"
    }, "System will generate a password and send to your email.")
  ])
], -1)
const _hoisted_129 = { class: "d-flex" }
const _hoisted_130 = ["data-kt-indicator"]
const _hoisted_131 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_132 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_133 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_logo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.entity_logo) = $event)),
                      name: "file_name",
                      ref: "fileInput",
                      onChange: _ctx.updatePhoto,
                      type: "file",
                      class: "form-control"
                    }, null, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.url
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_logo",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _hoisted_16,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Entity Type",
                          modelValue: _ctx.entity.entity_type_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.entity_type_id) = $event)),
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getEmployeeDesignation())),
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypes, (types) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: types.id,
                                label: types.name,
                                value: types.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(types.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "entity_type_id",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Industry Sector",
                          modelValue: _ctx.entity.entity_industry_sector,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entity.entity_industry_sector) = $event)),
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industry, (indus) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: indus.id,
                                label: indus.name,
                                value: indus.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(indus.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "industry_sector",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_Field, {
                          name: "entity_name",
                          class: "form-control",
                          modelValue: _ctx.entity.entity_name,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entity.entity_name) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "entity_name",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.entity.entity_short_name,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entity.entity_short_name) = $event)),
                          name: "entity_short_name",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "entity_short_name",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.entity.entity_registration_number,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entity.entity_registration_number) = $event)),
                          name: "registration_number",
                          class: "form-control",
                          value: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "registration_number",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_el_form_item, {
                          prop: "date",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.entity.entity_registration_date,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entity.entity_registration_date) = $event)),
                              "value-format": "YYYY-MM-DD",
                              format: "DD-MM-YYYY",
                              type: "date",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.entity.entity_registration_authority,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entity.entity_registration_authority) = $event)),
                          name: "registration_authority",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "registration_authority",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_telephone,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entity.entity_telephone) = $event)),
                      name: "telephone",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_fax,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entity.entity_fax) = $event)),
                      name: "fax",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_email,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entity.entity_email) = $event)),
                      name: "entityEmail",
                      type: "email",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entityEmail",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_web_url,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entity.entity_web_url) = $event)),
                      name: "web_url",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "web_url",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_address,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.entity.entity_address) = $event)),
                      name: "address",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Division",
                      modelValue: _ctx.entity.entity_division,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entity.entity_division) = $event)),
                      filterable: "",
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getDistrict())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.divisions, (division) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: division.id,
                            label: division.division_name_eng,
                            value: division.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(division.division_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select District",
                      modelValue: _ctx.entity.entity_district,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.entity.entity_district) = $event)),
                      filterable: "",
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getSubDistrict())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (district) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: district.id,
                            label: district.district_name_eng,
                            value: district.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Sub District",
                      modelValue: _ctx.entity.entity_sub_district,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entity.entity_sub_district) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subDistricts, (sub_district) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: sub_district.id,
                            label: sub_district.upazila_name_eng,
                            value: sub_district.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sub_district.upazila_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.entity.entity_postcode,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entity.entity_postcode) = $event)),
                      name: "postcode",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "postcode",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.entity.entity_description) = $event)),
                      name: "description",
                      class: "form-control",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.entity.entity_description]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "is_bill_author",
                        value: "0",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isBillAuthorCheck($event)))
                      }),
                      _hoisted_58
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_img,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.employee.employee_img) = $event)),
                    name: "employee_logo",
                    ref: "employeeFileInput",
                    onChange: _ctx.employeePhoto,
                    type: "file",
                    class: "form-control"
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_67, [
                    (_ctx.employee_url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.employee_url
                        }, null, 8, _hoisted_68))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "contact_person_image",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_name,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.employee.employee_name) = $event)),
                        type: "text",
                        name: "name",
                        class: "form-control",
                        rows: "3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "name",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Role",
                        modelValue: _ctx.employee.role,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.employee.role) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDesignation, (designation) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: designation.id,
                              label: designation.label,
                              value: designation.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(designation.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "designation",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createVNode(_component_el_form_item, {
                        prop: "date",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.employee.employee_dob,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.employee.employee_dob) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "dob",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_passport,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.employee.employee_passport) = $event)),
                        name: "passport",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_driving_license,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.employee.employee_driving_license) = $event)),
                        name: "driving_license",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_mobile,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.employee.employee_mobile) = $event)),
                        name: "mobile",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mobile",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_email,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                        name: "employeeEmail",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "employeeEmail",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createVNode(_component_Field, {
                        style: {"height":"auto !important"},
                        name: "gender",
                        modelValue: _ctx.employee.employee_gender,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.employee.employee_gender) = $event)),
                        class: "form-select form-select-lg",
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_89,
                          _hoisted_90,
                          _hoisted_91,
                          _hoisted_92
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "gender",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _createVNode(_component_Field, {
                        name: "religion",
                        modelValue: _ctx.employee.employee_religion,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.employee.employee_religion) = $event)),
                        class: "form-select",
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_95,
                          _hoisted_96,
                          _hoisted_97,
                          _hoisted_98,
                          _hoisted_99
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "religion",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.designation,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.employee.designation) = $event)),
                    name: "designation",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_nid,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.employee.employee_nid) = $event)),
                    name: "nid",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _hoisted_106,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_father_name,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.employee.employee_father_name) = $event)),
                    name: "fathers_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_mother_name,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.employee.employee_mother_name) = $event)),
                    name: "mothers_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _hoisted_111,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_present_address,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.employee.employee_present_address) = $event)),
                    name: "present_address",
                    class: "form-control",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _hoisted_113,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Present District",
                    modelValue: _ctx.employee.employee_present_district,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.employee.employee_present_district) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_permanent_address,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.employee.employee_permanent_address) = $event)),
                    name: "permanent_address",
                    class: "form-control"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _hoisted_118,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Permanent District",
                    modelValue: _ctx.employee.employee_permanent_district,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.employee.employee_permanent_district) = $event)),
                    name: "permanent_district",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_119, [
        _hoisted_120,
        _createElementVNode("div", _hoisted_121, [
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _hoisted_127,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.employee.employee_email,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                      name: "employeeEmail",
                      type: "email",
                      class: "form-control",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "employeeEmail",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _hoisted_128
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_129, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-success",
              type: "button",
              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.formSubmit()))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_131, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_132, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_133, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_134
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_130)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}